import { Branding, BrandingStyle, DisabledPrompt, Link, NavLink, useModel } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from "compid/custom-ui/CustomAccordion";
import React, { useRef } from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function NavView 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @example
* <PageView className="some-page">
*   <NavView />
*   <PageLayoutContainer>
*        <LeftColumnContainer>
*            <h1>Right content</h1>
*        </LeftColumnContainer>
*        <RightColumnContainer>
*            <h1>Right content</h1>
*       </RightColumnContainer>
*   </PageLayoutContainer>
* </PageView>
 */
export default function NavView(props) {
  const className = props.className ?? "";
  const model = useModel();
  const { options } = model.branding;
  //var isIntegrated = options.demo_integrated_rxp22 === "true" ? true : false;
  const hasZelle = options.zle_rpx22 === "true" ? true : false;
  const nav = useRef(null);
  // The "nav-view" is set to a css "sticky" top position of 75px by default.
  // Adjust the position here depending on branding for integration.
  /*useEffect(() => {
    if (isIntegrated) {
      nav.current.style.top = 0 + "px";
    }
  });*/

  return (
    <BrandingStyle style={{ "backgroundColor": "navigation_bar_bg_rxp22" }} className={className}>
      <div className="nav-container flex-container flex-horizontal align-bottom nav-view" ref={nav} >
        <div className="flex-width text-left flex-container align-center">
          <NavLink to="/PayBills" activeClassName="active-item" activeRoutes={["/PayBills"]} className="nav-link nav-item">
            <span data-point="Main_Menu_Pay_Bills">PAY BILLS</span>
          </NavLink>
          <NavLink to="/activity" activeClassName="active-item" activeRoutes={["/Activity", "/Activity/:billerID"]} className="nav-link nav-item" dataPoint="Activity_Tab">
            <span>ACTIVITY</span>
          </NavLink>
          {hasZelle &&
            <NavLink to="/zelle" activeClassName="active-item" activeRoutes={["/zelle"]} className="nav-link nav-item">
              <div className="flex-container flex-horizontal justify-center zelle-container">
                <span data-point="Zelle_Tab"><SVGAsset id="ZelleLogo" className="zelle-logo"  /></span>
              </div>
            </NavLink>

          }
        </div>

        { /**<Branding id="classic_view_rxp22" value="true">
          <DisabledPrompt>
            <div className="set-width justify-right classic-view flex-container align-center show-on-desktop">
              <p className="blue-text link">
                <span className="clickable">Switch to classic view</span>
              </p>
            </div>
          </DisabledPrompt>
        </Branding> */ }

        <Branding id="message_center_rxp22" value="true">
          <DisabledPrompt>
            <Link className="set-width justify-right messages-icon left-icon" dataPoint="messageIcon">
              <BrandingStyle style={{ "fill": "header_icon_rxp22" }} className="messages-icon" element={<SVGAsset id="MessagesIcon" />} />
            </Link>
          </DisabledPrompt>
        </Branding>
        <Branding id="help_guide_rxp22" value="true">
          <CustomAccordion className="set-width justify-right help-guide-accordion">
            <CustomAccordionToggle className="flex-container all-center">
              <div className="question-mark-icon left-icon">
                <BrandingStyle style={{ "fill": "header_icon_rxp22" }} className="question-mark-icon clickable" element={<SVGAsset id="QuestionMarkIcon" />} />
              </div>
            </CustomAccordionToggle>
            <CustomAccordionContent>
              <div className="help-guide-menu">
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Add biller</p>
                  </div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Edit biller</p>
                  </div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Edit payment</p>
                  </div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Make multiple payments</p>
                  </div>
                </DisabledPrompt>
              </div>
            </CustomAccordionContent>
          </CustomAccordion>
        </Branding>
        <Branding id="help_guide_rxp22" value="false">
          <DisabledPrompt>
            <div className="question-mark-icon set-width justify-right left-icon">
              <BrandingStyle style={{ "fill": "header_icon_rxp22" }} className="question-mark-icon clickable" element={<SVGAsset id="QuestionMarkIcon" />} />
            </div>
          </DisabledPrompt>
        </Branding>

      </div>
    </BrandingStyle>
  );
}
